<template>
  <div>
    <Filtro />
    <SimulacaoGrupo />
    <Importante />
    <Share :callback="retornoCotacao" />
    <ModalIdade />
    <ModalOperadora />
    <ModalProdutos />
    <ModalProdutosAdesao />
    <ModalProdutoGrupos />
  </div>
</template>

<script>
import lodash from "lodash";
import { mapActions, mapGetters } from "vuex"

import Importante from "@/components/Importante"
import Filtro from "@/components/Filtro"
import Share from "@/components/Share"
// import swal from "sweetalert";

import ModalIdade  from "@/components/ModalIdade"
import ModalOperadora from "@/components/ModalOperadora"
import ModalProdutos from "@/components/ModalProdutos"
import ModalProdutosAdesao from "@/components/ModalProdutosAdesao"
import ModalProdutoGrupos  from "@/components/ModalProdutoGrupos"

export default {
  data() {
    return {
      cotacao_id: null,
      cotacao_hash: null,
      operadoras: [],
      loadingOperadoras: false,
      produtos: [],
      produto: null,
      loadingProdutos: false,
      grupos: [],
      planos: [],
      loadingGrupos: false,
      operadoraSelecionado: {
        nome: null,
      },
      profissoes: [],
      cidades: [],
      credenciados: [],
      redes: [],
      localidades: [],
      coparticiacoes: [],
      opts: {
        checkbox: true,
        store: {
          store: this.$store,
          getter: () => {
            return this.$store.state.operadora.operadoraTree;
          },
          dispatcher: (newTree) => {
            this.$store.dispatch(
              "operadora/updateTree",
              this.$refs.tree.toJSON()
            );
          },
        },
      }
    };
  },
  computed: {
    ...mapGetters("share", {
      filtros: "getFiltros"
    }),
    ...mapGetters("cenario", {
      cenarios: "getCenarios",
    }),
    exibirCenarios() {
      return this.cenarios.length > 0;
    }
  },
  methods: {
    retornoCotacao(id, hash) {
      localStorage.setItem('cotacao_id', id)
      localStorage.setItem('cotacao_hash', hash)
      this.cotacao_id = id
      this.cotacao_hash = hash
      this.$route.query.hash = hash
    }
  },
  mounted() {
    this.$nextTick(function () {
      console.log("SimulacaoNova::mounted()");
      let vm = this
      this.$root
        .$off('bv::modal::hide')
        .$on('bv::modal::hide', async bvEvent => {
          let target  = bvEvent.target;
          console.log(target);
        })
    })
  },
  components: {
    Filtro,
    Importante,
    Share,
    ModalIdade,
    ModalOperadora,
    ModalProdutos,
    ModalProdutosAdesao,
    ModalProdutoGrupos,
    SimulacaoGrupo: () => import(/* webpackChunkName: "simulacao-chunk" */ "@/components/SimulacaoGrupo")
  },
};
</script>

<style lang="scss">
.error > div {
  border: 1px solid red;
}
.card label.btn-primary {
  color: #fff;
}
.btn-sm,
.btn-group-sm > .btn {
  font-size: 0.7rem !important;
}
.btn-primary:hover,
.btn-primary:focus,
.btn-primary:active,
.btn-primary.active,
.show > .btn-primary.dropdown-toggle {
  background-color: #f39c12 !important;
  color: #ffffff !important;
  border-color: #f39c12 !important;
}
.btn-primary:not(:disabled):not(.disabled):active,
.btn-primary:not(:disabled):not(.disabled).active,
.show > .btn-primary.dropdown-toggle {
  background-color: #f39c12 !important;
  color: #ffffff !important;
  border-color: #f39c12 !important;
}
.btn-light {
  color: #212529 !important;
  background-color: #f8f9fa !important;
  border-color: #f8f9fa !important;
  outline: 0 !important;
  box-shadow: none;
}
.btn.btn-light:hover,
.btn.btn-light:focus {
  box-shadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 2px;
}
.card-container {
  background-color: transparent;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.card-logo {
  padding: 4px;
  color: #757575;
  border-radius: 5px;
  background-color: #fff;
  -webkit-box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14),
    0 1px 5px 0 rgba(0, 0, 0, 0.12), 0 3px 1px -2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 1px 5px 0 rgba(0, 0, 0, 0.12),
    0 3px 1px -2px rgba(0, 0, 0, 0.2);
  width: 31%;
  margin: 3px 1% !important;
  text-align: center;
  cursor: pointer;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
}
.cenario {
  width: 100%;
  height: 100% !important;
  min-height: 100% !important;
  overflow-x: auto;
  overflow-y: visible;
}
.cenario-scroll {
  max-height: 100vh;
}
.form-control {
  font-size: 14px !important;
  border: 1px solid #eee !important;
  padding: 5px !important;
}
.suporte {
  color: #27a9f7;
  border: 1px solid #27a9f7;
  border-radius: 50%;
  font-size: 17px;
  padding: 4px;
}
.svg-inline--fa {
  display: inline-block;
  font-size: inherit;
  height: 1em;
  overflow: visible;
  vertical-align: -0.125em;
}

#input-live {
  background-color: rgb(255, 255, 255);
  margin-top: 5px;

  transform: to-lower-case($string: "A");
}
.checkBox-ml {
  margin-left: 24px;
}
</style>
